var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.665 28.47A15 15 0 1 0 24.335 3.53a15 15 0 0 0-16.67 24.94zm.657-23.966A13.822 13.822 0 1 1 23.695 27.48 13.822 13.822 0 0 1 8.322 4.504zm7.686-.192a11.66 11.66 0 0 0-7.87 3.055l-.842-.823a12.84 12.84 0 0 1 17.405 0l-.823.823a11.66 11.66 0 0 0-7.87-3.055zm8.63 3.808.824-.824v-.019a12.84 12.84 0 0 1 0 17.405l-.823-.823a11.66 11.66 0 0 0-.001-15.74zM7.368 23.866a11.66 11.66 0 0 1 0-15.73l-.824-.824a12.84 12.84 0 0 0 0 17.405l.823-.85zm8.63 3.817c2.912 0 5.72-1.09 7.869-3.056l.843.824a12.84 12.84 0 0 1-17.406.001l.824-.823a11.66 11.66 0 0 0 7.87 3.056zM21.2 13.25c-.165-1.717-1.647-2.294-3.523-2.47V8.413h-1.45v2.323H15.07V8.413h-1.44v2.384h-2.94v1.551s1.07-.02 1.054 0a.75.75 0 0 1 .824.637v6.524a.51.51 0 0 1-.176.353.5.5 0 0 1-.374.126c.02.016-1.054 0-1.054 0l-.274 1.732h2.913v2.422h1.45v-2.386h1.158v2.375h1.454v-2.394c2.449-.15 4.157-.754 4.37-3.046.174-1.846-.694-2.67-2.08-3.002.843-.414 1.364-1.183 1.246-2.44zm-2.032 5.158c0 1.653-2.6 1.615-3.788 1.598l-.28-.003v-3.196c.1 0 .222-.002.362-.005 1.22-.027 3.706-.082 3.706 1.606zm-.672-4.503c0 1.506-2.153 1.468-3.147 1.45h-.001l-.248-.003v-2.905c.082 0 .181-.003.294-.005 1.014-.027 3.1-.081 3.1 1.463z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbtc);
export default __webpack_public_path__ + "static/media/WBTC.42d181c9151f155e20a72e94bbceb536.svg";
export { ForwardRef as ReactComponent };